export const emojis = [
{ "emoji": "😀", "category": "peoples"},
{ "emoji": "😃", "category": "peoples"},
{ "emoji": "😄", "category": "peoples"},
{ "emoji": "😁", "category": "peoples"},
{ "emoji": "😆", "category": "peoples"},
{ "emoji": "😅", "category": "peoples"},
{ "emoji": "😂", "category": "peoples"},
{ "emoji": "🤣", "category": "peoples"},
{ "emoji": "😌", "category": "peoples"},
{ "emoji": "😊", "category": "peoples"},
{ "emoji": "😇", "category": "peoples"},
{ "emoji": "🙂", "category": "peoples"},
{ "emoji": "🙃", "category": "peoples"},
{ "emoji": "😉", "category": "peoples"},
{ "emoji": "😌", "category": "peoples"},
{ "emoji": "😍", "category": "peoples"},
{ "emoji": "😘", "category": "peoples"},
{ "emoji": "😗", "category": "peoples"},
{ "emoji": "😙", "category": "peoples"},
{ "emoji": "😚", "category": "peoples"},
{ "emoji": "😋", "category": "peoples"},
{ "emoji": "😜", "category": "peoples"},
{ "emoji": "😝", "category": "peoples"},
{ "emoji": "😛", "category": "peoples"},
{ "emoji": "🤑", "category": "peoples"},
{ "emoji": "🤗", "category": "peoples"},
{ "emoji": "🤓", "category": "peoples"},
{ "emoji": "😎", "category": "peoples"},
{ "emoji": "🤡", "category": "peoples"},
{ "emoji": "🤠", "category": "peoples"},
{ "emoji": "😏", "category": "peoples"},
{ "emoji": "😒", "category": "peoples"},
{ "emoji": "😞", "category": "peoples"},
{ "emoji": "😔", "category": "peoples"},
{ "emoji": "😟", "category": "peoples"},
{ "emoji": "😕", "category": "peoples"},
{ "emoji": "🙁", "category": "peoples"},
{ "emoji": "☹️", "category": "peoples"},
{ "emoji": "😣", "category": "peoples"},
{ "emoji": "😖", "category": "peoples"},
{ "emoji": "😫", "category": "peoples"},
{ "emoji": "😩", "category": "peoples"},
{ "emoji": "😤", "category": "peoples"},
{ "emoji": "😠", "category": "peoples"},
{ "emoji": "😡", "category": "peoples"},
{ "emoji": "😶", "category": "peoples"},
{ "emoji": "😐", "category": "peoples"},
{ "emoji": "😑", "category": "peoples"},
{ "emoji": "😯", "category": "peoples"},
{ "emoji": "😦", "category": "peoples"},
{ "emoji": "😧", "category": "peoples"},
{ "emoji": "😮", "category": "peoples"},
{ "emoji": "😲", "category": "peoples"},
{ "emoji": "😵", "category": "peoples"},
{ "emoji": "😳", "category": "peoples"},
{ "emoji": "😱", "category": "peoples"},
{ "emoji": "😨", "category": "peoples"},
{ "emoji": "😰", "category": "peoples"},
{ "emoji": "😢", "category": "peoples"},
{ "emoji": "😥", "category": "peoples"},
{ "emoji": "🤤", "category": "peoples"},
{ "emoji": "😭", "category": "peoples"},
{ "emoji": "😓", "category": "peoples"},
{ "emoji": "😪", "category": "peoples"},
{ "emoji": "😴", "category": "peoples"},
{ "emoji": "🙄", "category": "peoples"},
{ "emoji": "🤔", "category": "peoples"},
{ "emoji": "🤥", "category": "peoples"},
{ "emoji": "😬", "category": "peoples"},
{ "emoji": "🤐", "category": "peoples"},
{ "emoji": "🤢", "category": "peoples"},
{ "emoji": "🤧", "category": "peoples"},
{ "emoji": "😷", "category": "peoples"},
{ "emoji": "🤒", "category": "peoples"},
{ "emoji": "🤕", "category": "peoples"},
{ "emoji": "😈", "category": "peoples"},
{ "emoji": "👿", "category": "peoples"},
{ "emoji": "👹", "category": "peoples"},
{ "emoji": "👺", "category": "peoples"},
{ "emoji": "💩", "category": "peoples"},
{ "emoji": "👻", "category": "peoples"},
{ "emoji": "💀", "category": "peoples"},
{ "emoji": "☠️", "category": "peoples"},
{ "emoji": "👽", "category": "peoples"},
{ "emoji": "👾", "category": "peoples"},
{ "emoji": "🤖", "category": "peoples"},
{ "emoji": "🎃", "category": "peoples"},
{ "emoji": "😺", "category": "peoples"},
{ "emoji": "😸", "category": "peoples"},
{ "emoji": "😹", "category": "peoples"},
{ "emoji": "😻", "category": "peoples"},
{ "emoji": "😼", "category": "peoples"},
{ "emoji": "😽", "category": "peoples"},
{ "emoji": "🙀", "category": "peoples"},
{ "emoji": "😿", "category": "peoples"},
{ "emoji": "😾", "category": "peoples"},
{ "emoji": "👐", "category": "peoples"},
{ "emoji": "🙌", "category": "peoples"},
{ "emoji": "👏", "category": "peoples"},
{ "emoji": "🙏", "category": "peoples"},
{ "emoji": "🤝", "category": "peoples"},
{ "emoji": "👍", "category": "peoples"},
{ "emoji": "👎", "category": "peoples"},
{ "emoji": "👊", "category": "peoples"},
{ "emoji": "✊", "category": "peoples"},
{ "emoji": "🤛", "category": "peoples"},
{ "emoji": "🤜", "category": "peoples"},
{ "emoji": "🤞", "category": "peoples"},
{ "emoji": "✌️", "category": "peoples"},
{ "emoji": "🤘", "category": "peoples"},
{ "emoji": "👌", "category": "peoples"},
{ "emoji": "👈", "category": "peoples"},
{ "emoji": "👉", "category": "peoples"},
{ "emoji": "👆", "category": "peoples"},
{ "emoji": "👇", "category": "peoples"},
{ "emoji": "☝️", "category": "peoples"},
{ "emoji": "✋", "category": "peoples"},
{ "emoji": "🤚", "category": "peoples"},
{ "emoji": "🖐", "category": "peoples"},
{ "emoji": "🖖", "category": "peoples"},
{ "emoji": "👋", "category": "peoples"},
{ "emoji": "🤙", "category": "peoples"},
{ "emoji": "💪", "category": "peoples"},
{ "emoji": "🖕", "category": "peoples"},
{ "emoji": "✍️", "category": "peoples"},
{ "emoji": "🤳", "category": "peoples"},
{ "emoji": "💅", "category": "peoples"},
{ "emoji": "💍", "category": "peoples"},
{ "emoji": "💄", "category": "peoples"},
{ "emoji": "💋", "category": "peoples"},
{ "emoji": "👄", "category": "peoples"},
{ "emoji": "👅", "category": "peoples"},
{ "emoji": "👂", "category": "peoples"},
{ "emoji": "👃", "category": "peoples"},
{ "emoji": "👣", "category": "peoples"},
{ "emoji": "👁", "category": "peoples"},
{ "emoji": "👀", "category": "peoples"},
{ "emoji": "🗣", "category": "peoples"},
{ "emoji": "👤", "category": "peoples"},
{ "emoji": "👥", "category": "peoples"},
{ "emoji": "👶", "category": "peoples"},
{ "emoji": "👦", "category": "peoples"},
{ "emoji": "👧", "category": "peoples"},
{ "emoji": "👨", "category": "peoples"},
{ "emoji": "👩", "category": "peoples"},
{ "emoji": "👱‍♀", "category": "peoples"},
{ "emoji": "👱", "category": "peoples"},
{ "emoji": "👴", "category": "peoples"},
{ "emoji": "👵", "category": "peoples"},
{ "emoji": "👲", "category": "peoples"},
{ "emoji": "👳‍♀", "category": "peoples"},
{ "emoji": "👳", "category": "peoples"},
{ "emoji": "👮‍♀", "category": "peoples"},
{ "emoji": "👮", "category": "peoples"},
{ "emoji": "👷‍♀", "category": "peoples"},
{ "emoji": "👷", "category": "peoples"},
{ "emoji": "💂‍♀", "category": "peoples"},
{ "emoji": "💂", "category": "peoples"},
{ "emoji": "👩‍⚕", "category": "peoples"},
{ "emoji": "👨‍⚕", "category": "peoples"},
{ "emoji": "👩‍🌾", "category": "peoples"},
{ "emoji": "👨‍🌾", "category": "peoples"},
{ "emoji": "👩‍🍳", "category": "peoples"},
{ "emoji": "👨‍🍳", "category": "peoples"},
{ "emoji": "👩‍🎓", "category": "peoples"},
{ "emoji": "👨‍🎓", "category": "peoples"},
{ "emoji": "👩‍🎤", "category": "peoples"},
{ "emoji": "👨‍🎤", "category": "peoples"},
{ "emoji": "👩‍🏫", "category": "peoples"},
{ "emoji": "👨‍🏫", "category": "peoples"},
{ "emoji": "👩‍🏭", "category": "peoples"},
{ "emoji": "👨‍🏭", "category": "peoples"},
{ "emoji": "👩‍💻", "category": "peoples"},
{ "emoji": "👨‍💻", "category": "peoples"},
{ "emoji": "👩‍💼", "category": "peoples"},
{ "emoji": "👨‍💼", "category": "peoples"},
{ "emoji": "👩‍🔧", "category": "peoples"},
{ "emoji": "👨‍🔧", "category": "peoples"},
{ "emoji": "👩‍🔬", "category": "peoples"},
{ "emoji": "👨‍🔬", "category": "peoples"},
{ "emoji": "👩‍🎨", "category": "peoples"},
{ "emoji": "👨‍🎨", "category": "peoples"},
{ "emoji": "👩‍🚒", "category": "peoples"},
{ "emoji": "👨‍🚒", "category": "peoples"},
{ "emoji": "👩‍🚀", "category": "peoples"},
{ "emoji": "👨‍🚀", "category": "peoples"},
{ "emoji": "🤶", "category": "peoples"},
{ "emoji": "🎅", "category": "peoples"},
{ "emoji": "👸", "category": "peoples"},
{ "emoji": "🤴", "category": "peoples"},
{ "emoji": "👰", "category": "peoples"},
{ "emoji": "🤵", "category": "peoples"},
{ "emoji": "👼", "category": "peoples"},
{ "emoji": "🤰", "category": "peoples"},
{ "emoji": "🙇‍♀", "category": "peoples"},
{ "emoji": "🙇", "category": "peoples"},
{ "emoji": "💁", "category": "peoples"},
{ "emoji": "💁‍♂", "category": "peoples"},
{ "emoji": "🙅", "category": "peoples"},
{ "emoji": "🙅‍♂", "category": "peoples"},
{ "emoji": "🙆", "category": "peoples"},
{ "emoji": "🙆‍♂", "category": "peoples"},
{ "emoji": "🙋", "category": "peoples"},
{ "emoji": "🙋‍♂", "category": "peoples"},
{ "emoji": "🤦‍♀", "category": "peoples"},
{ "emoji": "🤦‍♂", "category": "peoples"},
{ "emoji": "🤷‍♀", "category": "peoples"},
{ "emoji": "🤷‍♂", "category": "peoples"},
{ "emoji": "🙎", "category": "peoples"},
{ "emoji": "🙎‍♂", "category": "peoples"},
{ "emoji": "🙍", "category": "peoples"},
{ "emoji": "🙍‍♂", "category": "peoples"},
{ "emoji": "💇", "category": "peoples"},
{ "emoji": "💇‍♂", "category": "peoples"},
{ "emoji": "💆", "category": "peoples"},
{ "emoji": "💆‍♂", "category": "peoples"},
{ "emoji": "🕴", "category": "peoples"},
{ "emoji": "💃", "category": "peoples"},
{ "emoji": "🕺", "category": "peoples"},
{ "emoji": "👯", "category": "peoples"},
{ "emoji": "👯‍♂", "category": "peoples"},
{ "emoji": "🚶‍♀", "category": "peoples"},
{ "emoji": "🚶", "category": "peoples"},
{ "emoji": "🏃‍♀", "category": "peoples"},
{ "emoji": "🏃", "category": "peoples"},
{ "emoji": "👫", "category": "peoples"},
{ "emoji": "👭", "category": "peoples"},
{ "emoji": "👬", "category": "peoples"},
{ "emoji": "💑", "category": "peoples"},
{ "emoji": "👩‍❤️‍👩", "category": "peoples"},
{ "emoji": "👨‍❤️‍👨", "category": "peoples"},
{ "emoji": "💏", "category": "peoples"},
{ "emoji": "👩‍❤️‍💋‍👩", "category": "peoples"},
{ "emoji": "👨‍❤️‍💋‍👨", "category": "peoples"},
{ "emoji": "👪", "category": "peoples"},
{ "emoji": "👨‍👩‍👧", "category": "peoples"},
{ "emoji": "👨‍👩‍👧‍👦", "category": "peoples"},
{ "emoji": "👨‍👩‍👦‍👦", "category": "peoples"},
{ "emoji": "👨‍👩‍👧‍👧", "category": "peoples"},
{ "emoji": "👩‍👩‍👦", "category": "peoples"},
{ "emoji": "👩‍👩‍👧", "category": "peoples"},
{ "emoji": "👩‍👩‍👧‍👦", "category": "peoples"},
{ "emoji": "👩‍👩‍👦‍👦", "category": "peoples"},
{ "emoji": "👩‍👩‍👧‍👧", "category": "peoples"},
{ "emoji": "👨‍👨‍👦", "category": "peoples"},
{ "emoji": "👨‍👨‍👧", "category": "peoples"},
{ "emoji": "👨‍👨‍👧‍👦", "category": "peoples"},
{ "emoji": "👨‍👨‍👦‍👦", "category": "peoples"},
{ "emoji": "👨‍👨‍👧‍👧", "category": "peoples"},
{ "emoji": "👩‍👦", "category": "peoples"},
{ "emoji": "👩‍👧", "category": "peoples"},
{ "emoji": "👩‍👧‍👦", "category": "peoples"},
{ "emoji": "👩‍👦‍👦", "category": "peoples"},
{ "emoji": "👩‍👧‍👧", "category": "peoples"},
{ "emoji": "👨‍👦", "category": "peoples"},
{ "emoji": "👨‍👧", "category": "peoples"},
{ "emoji": "👨‍👧‍👦", "category": "peoples"},
{ "emoji": "👨‍👦‍👦", "category": "peoples"},
{ "emoji": "👨‍👧‍👧", "category": "peoples"},
{ "emoji": "👚", "category": "peoples"},
{ "emoji": "👕", "category": "peoples"},
{ "emoji": "👖", "category": "peoples"},
{ "emoji": "👔", "category": "peoples"},
{ "emoji": "👗", "category": "peoples"},
{ "emoji": "👙", "category": "peoples"},
{ "emoji": "👘", "category": "peoples"},
{ "emoji": "👠", "category": "peoples"},
{ "emoji": "👡", "category": "peoples"},
{ "emoji": "👢", "category": "peoples"},
{ "emoji": "👞", "category": "peoples"},
{ "emoji": "👟", "category": "peoples"},
{ "emoji": "👒", "category": "peoples"},
{ "emoji": "🎩", "category": "peoples"},
{ "emoji": "🎓", "category": "peoples"},
{ "emoji": "👑", "category": "peoples"},
{ "emoji": "⛑", "category": "peoples"},
{ "emoji": "🎒", "category": "peoples"},
{ "emoji": "👝", "category": "peoples"},
{ "emoji": "👛", "category": "peoples"},
{ "emoji": "👜", "category": "peoples"},
{ "emoji": "💼", "category": "peoples"},
{ "emoji": "👓", "category": "peoples"},
{ "emoji": "🕶", "category": "peoples"},
{ "emoji": "🌂", "category": "peoples"},
{ "emoji": "☂️", "category": "peoples"},
{ "emoji": "🐶", "category": "nature"},
{ "emoji": "🐱", "category": "nature"},
{ "emoji": "🐭", "category": "nature"},
{ "emoji": "🐹", "category": "nature"},
{ "emoji": "🐰", "category": "nature"},
{ "emoji": "🦊", "category": "nature"},
{ "emoji": "🐻", "category": "nature"},
{ "emoji": "🐼", "category": "nature"},
{ "emoji": "🐨", "category": "nature"},
{ "emoji": "🐯", "category": "nature"},
{ "emoji": "🦁", "category": "nature"},
{ "emoji": "🐮", "category": "nature"},
{ "emoji": "🐷", "category": "nature"},
{ "emoji": "🐽", "category": "nature"},
{ "emoji": "🐸", "category": "nature"},
{ "emoji": "🐵", "category": "nature"},
{ "emoji": "🙈", "category": "nature"},
{ "emoji": "🙉", "category": "nature"},
{ "emoji": "🙊", "category": "nature"},
{ "emoji": "🐒", "category": "nature"},
{ "emoji": "🐔", "category": "nature"},
{ "emoji": "🐧", "category": "nature"},
{ "emoji": "🐦", "category": "nature"},
{ "emoji": "🐤", "category": "nature"},
{ "emoji": "🐣", "category": "nature"},
{ "emoji": "🐥", "category": "nature"},
{ "emoji": "🦆", "category": "nature"},
{ "emoji": "🦅", "category": "nature"},
{ "emoji": "🦉", "category": "nature"},
{ "emoji": "🦇", "category": "nature"},
{ "emoji": "🐺", "category": "nature"},
{ "emoji": "🐗", "category": "nature"},
{ "emoji": "🐴", "category": "nature"},
{ "emoji": "🦄", "category": "nature"},
{ "emoji": "🐝", "category": "nature"},
{ "emoji": "🐛", "category": "nature"},
{ "emoji": "🦋", "category": "nature"},
{ "emoji": "🐌", "category": "nature"},
{ "emoji": "🐚", "category": "nature"},
{ "emoji": "🐞", "category": "nature"},
{ "emoji": "🐜", "category": "nature"},
{ "emoji": "🕷", "category": "nature"},
{ "emoji": "🕸", "category": "nature"},
{ "emoji": "🐢", "category": "nature"},
{ "emoji": "🐍", "category": "nature"},
{ "emoji": "🦎", "category": "nature"},
{ "emoji": "🦂", "category": "nature"},
{ "emoji": "🦀", "category": "nature"},
{ "emoji": "🦑", "category": "nature"},
{ "emoji": "🐙", "category": "nature"},
{ "emoji": "🦐", "category": "nature"},
{ "emoji": "🐠", "category": "nature"},
{ "emoji": "🐟", "category": "nature"},
{ "emoji": "🐡", "category": "nature"},
{ "emoji": "🐬", "category": "nature"},
{ "emoji": "🦈", "category": "nature"},
{ "emoji": "🐳", "category": "nature"},
{ "emoji": "🐋", "category": "nature"},
{ "emoji": "🐊", "category": "nature"},
{ "emoji": "🐆", "category": "nature"},
{ "emoji": "🐅", "category": "nature"},
{ "emoji": "🐃", "category": "nature"},
{ "emoji": "🐂", "category": "nature"},
{ "emoji": "🐄", "category": "nature"},
{ "emoji": "🦌", "category": "nature"},
{ "emoji": "🐪", "category": "nature"},
{ "emoji": "🐫", "category": "nature"},
{ "emoji": "🐘", "category": "nature"},
{ "emoji": "🦏", "category": "nature"},
{ "emoji": "🦍", "category": "nature"},
{ "emoji": "🐎", "category": "nature"},
{ "emoji": "🐖", "category": "nature"},
{ "emoji": "🐐", "category": "nature"},
{ "emoji": "🐏", "category": "nature"},
{ "emoji": "🐑", "category": "nature"},
{ "emoji": "🐕", "category": "nature"},
{ "emoji": "🐩", "category": "nature"},
{ "emoji": "🐈", "category": "nature"},
{ "emoji": "🐓", "category": "nature"},
{ "emoji": "🦃", "category": "nature"},
{ "emoji": "🕊", "category": "nature"},
{ "emoji": "🐇", "category": "nature"},
{ "emoji": "🐁", "category": "nature"},
{ "emoji": "🐀", "category": "nature"},
{ "emoji": "🐿", "category": "nature"},
{ "emoji": "🐾", "category": "nature"},
{ "emoji": "🐉", "category": "nature"},
{ "emoji": "🐲", "category": "nature"},
{ "emoji": "🌵", "category": "nature"},
{ "emoji": "🎄", "category": "nature"},
{ "emoji": "🌲", "category": "nature"},
{ "emoji": "🌳", "category": "nature"},
{ "emoji": "🌴", "category": "nature"},
{ "emoji": "🌱", "category": "nature"},
{ "emoji": "🌿", "category": "nature"},
{ "emoji": "☘️", "category": "nature"},
{ "emoji": "🍀", "category": "nature"},
{ "emoji": "🎍", "category": "nature"},
{ "emoji": "🎋", "category": "nature"},
{ "emoji": "🍃", "category": "nature"},
{ "emoji": "🍂", "category": "nature"},
{ "emoji": "🍁", "category": "nature"},
{ "emoji": "🍄", "category": "nature"},
{ "emoji": "🌾", "category": "nature"},
{ "emoji": "💐", "category": "nature"},
{ "emoji": "🌷", "category": "nature"},
{ "emoji": "🌹", "category": "nature"},
{ "emoji": "🥀", "category": "nature"},
{ "emoji": "🌻", "category": "nature"},
{ "emoji": "🌼", "category": "nature"},
{ "emoji": "🌸", "category": "nature"},
{ "emoji": "🌺", "category": "nature"},
{ "emoji": "🌎", "category": "nature"},
{ "emoji": "🌍", "category": "nature"},
{ "emoji": "🌏", "category": "nature"},
{ "emoji": "🌕", "category": "nature"},
{ "emoji": "🌖", "category": "nature"},
{ "emoji": "🌗", "category": "nature"},
{ "emoji": "🌘", "category": "nature"},
{ "emoji": "🌑", "category": "nature"},
{ "emoji": "🌒", "category": "nature"},
{ "emoji": "🌓", "category": "nature"},
{ "emoji": "🌔", "category": "nature"},
{ "emoji": "🌚", "category": "nature"},
{ "emoji": "🌝", "category": "nature"},
{ "emoji": "🌞", "category": "nature"},
{ "emoji": "🌛", "category": "nature"},
{ "emoji": "🌜", "category": "nature"},
{ "emoji": "🌙", "category": "nature"},
{ "emoji": "💫", "category": "nature"},
{ "emoji": "⭐️", "category": "nature"},
{ "emoji": "🌟", "category": "nature"},
{ "emoji": "✨", "category": "nature"},
{ "emoji": "⚡️", "category": "nature"},
{ "emoji": "🔥", "category": "nature"},
{ "emoji": "💥", "category": "nature"},
{ "emoji": "☄", "category": "nature"},
{ "emoji": "☀️", "category": "nature"},
{ "emoji": "🌤", "category": "nature"},
{ "emoji": "⛅️", "category": "nature"},
{ "emoji": "🌥", "category": "nature"},
{ "emoji": "🌦", "category": "nature"},
{ "emoji": "🌈", "category": "nature"},
{ "emoji": "☁️", "category": "nature"},
{ "emoji": "🌧", "category": "nature"},
{ "emoji": "⛈", "category": "nature"},
{ "emoji": "🌩", "category": "nature"},
{ "emoji": "🌨", "category": "nature"},
{ "emoji": "☃️", "category": "nature"},
{ "emoji": "⛄️", "category": "nature"},
{ "emoji": "❄️", "category": "nature"},
{ "emoji": "🌬", "category": "nature"},
{ "emoji": "💨", "category": "nature"},
{ "emoji": "🌪", "category": "nature"},
{ "emoji": "🌫", "category": "nature"},
{ "emoji": "🌊", "category": "nature"},
{ "emoji": "💧", "category": "nature"},
{ "emoji": "💦", "category": "nature"},
{ "emoji": "☔️", "category": "nature"},
{ "emoji": "🍏", "category": "foods"},
{ "emoji": "🍎", "category": "foods"},
{ "emoji": "🍐", "category": "foods"},
{ "emoji": "🍊", "category": "foods"},
{ "emoji": "🍋", "category": "foods"},
{ "emoji": "🍌", "category": "foods"},
{ "emoji": "🍉", "category": "foods"},
{ "emoji": "🍇", "category": "foods"},
{ "emoji": "🍓", "category": "foods"},
{ "emoji": "🍈", "category": "foods"},
{ "emoji": "🍒", "category": "foods"},
{ "emoji": "🍑", "category": "foods"},
{ "emoji": "🍍", "category": "foods"},
{ "emoji": "🥝", "category": "foods"},
{ "emoji": "🥑", "category": "foods"},
{ "emoji": "🍅", "category": "foods"},
{ "emoji": "🍆", "category": "foods"},
{ "emoji": "🥒", "category": "foods"},
{ "emoji": "🥕", "category": "foods"},
{ "emoji": "🌽", "category": "foods"},
{ "emoji": "🌶", "category": "foods"},
{ "emoji": "🥔", "category": "foods"},
{ "emoji": "🍠", "category": "foods"},
{ "emoji": "🌰", "category": "foods"},
{ "emoji": "🥜", "category": "foods"},
{ "emoji": "🍯", "category": "foods"},
{ "emoji": "🥐", "category": "foods"},
{ "emoji": "🍞", "category": "foods"},
{ "emoji": "🥖", "category": "foods"},
{ "emoji": "🧀", "category": "foods"},
{ "emoji": "🥚", "category": "foods"},
{ "emoji": "🍳", "category": "foods"},
{ "emoji": "🥓", "category": "foods"},
{ "emoji": "🥞", "category": "foods"},
{ "emoji": "🍤", "category": "foods"},
{ "emoji": "🍗", "category": "foods"},
{ "emoji": "🍖", "category": "foods"},
{ "emoji": "🍕", "category": "foods"},
{ "emoji": "🌭", "category": "foods"},
{ "emoji": "🍔", "category": "foods"},
{ "emoji": "🍟", "category": "foods"},
{ "emoji": "🥙", "category": "foods"},
{ "emoji": "🌮", "category": "foods"},
{ "emoji": "🌯", "category": "foods"},
{ "emoji": "🥗", "category": "foods"},
{ "emoji": "🥘", "category": "foods"},
{ "emoji": "🍝", "category": "foods"},
{ "emoji": "🍜", "category": "foods"},
{ "emoji": "🍲", "category": "foods"},
{ "emoji": "🍥", "category": "foods"},
{ "emoji": "🍣", "category": "foods"},
{ "emoji": "🍱", "category": "foods"},
{ "emoji": "🍛", "category": "foods"},
{ "emoji": "🍚", "category": "foods"},
{ "emoji": "🍙", "category": "foods"},
{ "emoji": "🍘", "category": "foods"},
{ "emoji": "🍢", "category": "foods"},
{ "emoji": "🍡", "category": "foods"},
{ "emoji": "🍧", "category": "foods"},
{ "emoji": "🍨", "category": "foods"},
{ "emoji": "🍦", "category": "foods"},
{ "emoji": "🍰", "category": "foods"},
{ "emoji": "🎂", "category": "foods"},
{ "emoji": "🍮", "category": "foods"},
{ "emoji": "🍭", "category": "foods"},
{ "emoji": "🍬", "category": "foods"},
{ "emoji": "🍫", "category": "foods"},
{ "emoji": "🍿", "category": "foods"},
{ "emoji": "🍩", "category": "foods"},
{ "emoji": "🍪", "category": "foods"},
{ "emoji": "🥛", "category": "foods"},
{ "emoji": "🍼", "category": "foods"},
{ "emoji": "☕️", "category": "foods"},
{ "emoji": "🍵", "category": "foods"},
{ "emoji": "🍶", "category": "foods"},
{ "emoji": "🍺", "category": "foods"},
{ "emoji": "🍻", "category": "foods"},
{ "emoji": "🥂", "category": "foods"},
{ "emoji": "🍷", "category": "foods"},
{ "emoji": "🥃", "category": "foods"},
{ "emoji": "🍸", "category": "foods"},
{ "emoji": "🍹", "category": "foods"},
{ "emoji": "🍾", "category": "foods"},
{ "emoji": "🥄", "category": "foods"},
{ "emoji": "🍴", "category": "foods"},
{ "emoji": "🍽", "category": "foods"},
{ "emoji": "⚽️", "category": "activity"},
{ "emoji": "🏀", "category": "activity"},
{ "emoji": "🏈", "category": "activity"},
{ "emoji": "⚾️", "category": "activity"},
{ "emoji": "🎾", "category": "activity"},
{ "emoji": "🏐", "category": "activity"},
{ "emoji": "🏉", "category": "activity"},
{ "emoji": "🎱", "category": "activity"},
{ "emoji": "🏓", "category": "activity"},
{ "emoji": "🏸", "category": "activity"},
{ "emoji": "🥅", "category": "activity"},
{ "emoji": "🏒", "category": "activity"},
{ "emoji": "🏑", "category": "activity"},
{ "emoji": "🏏", "category": "activity"},
{ "emoji": "⛳️", "category": "activity"},
{ "emoji": "🏹", "category": "activity"},
{ "emoji": "🎣", "category": "activity"},
{ "emoji": "🥊", "category": "activity"},
{ "emoji": "🥋", "category": "activity"},
{ "emoji": "⛸", "category": "activity"},
{ "emoji": "🎿", "category": "activity"},
{ "emoji": "⛷", "category": "activity"},
{ "emoji": "🏂", "category": "activity"},
{ "emoji": "🏋️‍♀️", "category": "activity"},
{ "emoji": "🏋", "category": "activity"},
{ "emoji": "🤺", "category": "activity"},
{ "emoji": "🤼‍♀", "category": "activity"},
{ "emoji": "🤼‍♂", "category": "activity"},
{ "emoji": "🤸‍♀", "category": "activity"},
{ "emoji": "🤸‍♂", "category": "activity"},
{ "emoji": "⛹️‍♀️", "category": "activity"},
{ "emoji": "⛹", "category": "activity"},
{ "emoji": "🤾‍♀", "category": "activity"},
{ "emoji": "🤾‍♂", "category": "activity"},
{ "emoji": "🏌️‍♀️", "category": "activity"},
{ "emoji": "🏌", "category": "activity"},
{ "emoji": "🏄‍♀", "category": "activity"},
{ "emoji": "🏄", "category": "activity"},
{ "emoji": "🏊‍♀", "category": "activity"},
{ "emoji": "🏊", "category": "activity"},
{ "emoji": "🤽‍♀", "category": "activity"},
{ "emoji": "🤽‍♂", "category": "activity"},
{ "emoji": "🚣‍♀", "category": "activity"},
{ "emoji": "🚣", "category": "activity"},
{ "emoji": "🏇", "category": "activity"},
{ "emoji": "🚴‍♀", "category": "activity"},
{ "emoji": "🚴", "category": "activity"},
{ "emoji": "🚵‍♀", "category": "activity"},
{ "emoji": "🚵", "category": "activity"},
{ "emoji": "🎽", "category": "activity"},
{ "emoji": "🏅", "category": "activity"},
{ "emoji": "🎖", "category": "activity"},
{ "emoji": "🥇", "category": "activity"},
{ "emoji": "🥈", "category": "activity"},
{ "emoji": "🥉", "category": "activity"},
{ "emoji": "🏆", "category": "activity"},
{ "emoji": "🏵", "category": "activity"},
{ "emoji": "🎗", "category": "activity"},
{ "emoji": "🎫", "category": "activity"},
{ "emoji": "🎟", "category": "activity"},
{ "emoji": "🎪", "category": "activity"},
{ "emoji": "🤹‍♀", "category": "activity"},
{ "emoji": "🤹‍♂", "category": "activity"},
{ "emoji": "🎭", "category": "activity"},
{ "emoji": "🎨", "category": "activity"},
{ "emoji": "🎬", "category": "activity"},
{ "emoji": "🎤", "category": "activity"},
{ "emoji": "🎧", "category": "activity"},
{ "emoji": "🎼", "category": "activity"},
{ "emoji": "🎹", "category": "activity"},
{ "emoji": "🥁", "category": "activity"},
{ "emoji": "🎷", "category": "activity"},
{ "emoji": "🎺", "category": "activity"},
{ "emoji": "🎸", "category": "activity"},
{ "emoji": "🎻", "category": "activity"},
{ "emoji": "🎲", "category": "activity"},
{ "emoji": "🎯", "category": "activity"},
{ "emoji": "🎳", "category": "activity"},
{ "emoji": "🎮", "category": "activity"},
{ "emoji": "🎰", "category": "activity"},
{ "emoji": "🚗", "category": "places"},
{ "emoji": "🚕", "category": "places"},
{ "emoji": "🚙", "category": "places"},
{ "emoji": "🚌", "category": "places"},
{ "emoji": "🚎", "category": "places"},
{ "emoji": "🏎", "category": "places"},
{ "emoji": "🚓", "category": "places"},
{ "emoji": "🚑", "category": "places"},
{ "emoji": "🚒", "category": "places"},
{ "emoji": "🚐", "category": "places"},
{ "emoji": "🚚", "category": "places"},
{ "emoji": "🚛", "category": "places"},
{ "emoji": "🚜", "category": "places"},
{ "emoji": "🛴", "category": "places"},
{ "emoji": "🚲", "category": "places"},
{ "emoji": "🛵", "category": "places"},
{ "emoji": "🏍", "category": "places"},
{ "emoji": "🚨", "category": "places"},
{ "emoji": "🚔", "category": "places"},
{ "emoji": "🚍", "category": "places"},
{ "emoji": "🚘", "category": "places"},
{ "emoji": "🚖", "category": "places"},
{ "emoji": "🚡", "category": "places"},
{ "emoji": "🚠", "category": "places"},
{ "emoji": "🚟", "category": "places"},
{ "emoji": "🚃", "category": "places"},
{ "emoji": "🚋", "category": "places"},
{ "emoji": "🚞", "category": "places"},
{ "emoji": "🚝", "category": "places"},
{ "emoji": "🚄", "category": "places"},
{ "emoji": "🚅", "category": "places"},
{ "emoji": "🚈", "category": "places"},
{ "emoji": "🚂", "category": "places"},
{ "emoji": "🚆", "category": "places"},
{ "emoji": "🚇", "category": "places"},
{ "emoji": "🚊", "category": "places"},
{ "emoji": "🚉", "category": "places"},
{ "emoji": "🚁", "category": "places"},
{ "emoji": "🛩", "category": "places"},
{ "emoji": "✈️", "category": "places"},
{ "emoji": "🛫", "category": "places"},
{ "emoji": "🛬", "category": "places"},
{ "emoji": "🚀", "category": "places"},
{ "emoji": "🛰", "category": "places"},
{ "emoji": "💺", "category": "places"},
{ "emoji": "🛶", "category": "places"},
{ "emoji": "⛵️", "category": "places"},
{ "emoji": "🛥", "category": "places"},
{ "emoji": "🚤", "category": "places"},
{ "emoji": "🛳", "category": "places"},
{ "emoji": "⛴", "category": "places"},
{ "emoji": "🚢", "category": "places"},
{ "emoji": "⚓️", "category": "places"},
{ "emoji": "🚧", "category": "places"},
{ "emoji": "⛽️", "category": "places"},
{ "emoji": "🚏", "category": "places"},
{ "emoji": "🚦", "category": "places"},
{ "emoji": "🚥", "category": "places"},
{ "emoji": "🗺", "category": "places"},
{ "emoji": "🗿", "category": "places"},
{ "emoji": "🗽", "category": "places"},
{ "emoji": "⛲️", "category": "places"},
{ "emoji": "🗼", "category": "places"},
{ "emoji": "🏰", "category": "places"},
{ "emoji": "🏯", "category": "places"},
{ "emoji": "🏟", "category": "places"},
{ "emoji": "🎡", "category": "places"},
{ "emoji": "🎢", "category": "places"},
{ "emoji": "🎠", "category": "places"},
{ "emoji": "⛱", "category": "places"},
{ "emoji": "🏖", "category": "places"},
{ "emoji": "🏝", "category": "places"},
{ "emoji": "⛰", "category": "places"},
{ "emoji": "🏔", "category": "places"},
{ "emoji": "🗻", "category": "places"},
{ "emoji": "🌋", "category": "places"},
{ "emoji": "🏜", "category": "places"},
{ "emoji": "🏕", "category": "places"},
{ "emoji": "⛺️", "category": "places"},
{ "emoji": "🛤", "category": "places"},
{ "emoji": "🛣", "category": "places"},
{ "emoji": "🏗", "category": "places"},
{ "emoji": "🏭", "category": "places"},
{ "emoji": "🏠", "category": "places"},
{ "emoji": "🏡", "category": "places"},
{ "emoji": "🏘", "category": "places"},
{ "emoji": "🏚", "category": "places"},
{ "emoji": "🏢", "category": "places"},
{ "emoji": "🏬", "category": "places"},
{ "emoji": "🏣", "category": "places"},
{ "emoji": "🏤", "category": "places"},
{ "emoji": "🏥", "category": "places"},
{ "emoji": "🏦", "category": "places"},
{ "emoji": "🏨", "category": "places"},
{ "emoji": "🏪", "category": "places"},
{ "emoji": "🏫", "category": "places"},
{ "emoji": "🏩", "category": "places"},
{ "emoji": "💒", "category": "places"},
{ "emoji": "🏛", "category": "places"},
{ "emoji": "⛪️", "category": "places"},
{ "emoji": "🕌", "category": "places"},
{ "emoji": "🕍", "category": "places"},
{ "emoji": "🕋", "category": "places"},
{ "emoji": "⛩", "category": "places"},
{ "emoji": "🗾", "category": "places"},
{ "emoji": "🎑", "category": "places"},
{ "emoji": "🏞", "category": "places"},
{ "emoji": "🌅", "category": "places"},
{ "emoji": "🌄", "category": "places"},
{ "emoji": "🌠", "category": "places"},
{ "emoji": "🎇", "category": "places"},
{ "emoji": "🎆", "category": "places"},
{ "emoji": "🌇", "category": "places"},
{ "emoji": "🌆", "category": "places"},
{ "emoji": "🏙", "category": "places"},
{ "emoji": "🌃", "category": "places"},
{ "emoji": "🌌", "category": "places"},
{ "emoji": "🌉", "category": "places"},
{ "emoji": "🌁", "category": "places"},
{ "emoji": "⌚️", "category": "objects"},
{ "emoji": "📱", "category": "objects"},
{ "emoji": "📲", "category": "objects"},
{ "emoji": "💻", "category": "objects"},
{ "emoji": "⌨️", "category": "objects"},
{ "emoji": "🖥", "category": "objects"},
{ "emoji": "🖨", "category": "objects"},
{ "emoji": "🖱", "category": "objects"},
{ "emoji": "🖲", "category": "objects"},
{ "emoji": "🕹", "category": "objects"},
{ "emoji": "🗜", "category": "objects"},
{ "emoji": "💽", "category": "objects"},
{ "emoji": "💾", "category": "objects"},
{ "emoji": "💿", "category": "objects"},
{ "emoji": "📀", "category": "objects"},
{ "emoji": "📼", "category": "objects"},
{ "emoji": "📷", "category": "objects"},
{ "emoji": "📸", "category": "objects"},
{ "emoji": "📹", "category": "objects"},
{ "emoji": "🎥", "category": "objects"},
{ "emoji": "📽", "category": "objects"},
{ "emoji": "🎞", "category": "objects"},
{ "emoji": "📞", "category": "objects"},
{ "emoji": "☎️", "category": "objects"},
{ "emoji": "📟", "category": "objects"},
{ "emoji": "📠", "category": "objects"},
{ "emoji": "📺", "category": "objects"},
{ "emoji": "📻", "category": "objects"},
{ "emoji": "🎙", "category": "objects"},
{ "emoji": "🎚", "category": "objects"},
{ "emoji": "🎛", "category": "objects"},
{ "emoji": "⏱", "category": "objects"},
{ "emoji": "⏲", "category": "objects"},
{ "emoji": "⏰", "category": "objects"},
{ "emoji": "🕰", "category": "objects"},
{ "emoji": "⌛️", "category": "objects"},
{ "emoji": "⏳", "category": "objects"},
{ "emoji": "📡", "category": "objects"},
{ "emoji": "🔋", "category": "objects"},
{ "emoji": "🔌", "category": "objects"},
{ "emoji": "💡", "category": "objects"},
{ "emoji": "🔦", "category": "objects"},
{ "emoji": "🕯", "category": "objects"},
{ "emoji": "🗑", "category": "objects"},
{ "emoji": "🛢", "category": "objects"},
{ "emoji": "💸", "category": "objects"},
{ "emoji": "💵", "category": "objects"},
{ "emoji": "💴", "category": "objects"},
{ "emoji": "💶", "category": "objects"},
{ "emoji": "💷", "category": "objects"},
{ "emoji": "💰", "category": "objects"},
{ "emoji": "💳", "category": "objects"},
{ "emoji": "💎", "category": "objects"},
{ "emoji": "⚖️", "category": "objects"},
{ "emoji": "🔧", "category": "objects"},
{ "emoji": "🔨", "category": "objects"},
{ "emoji": "⚒", "category": "objects"},
{ "emoji": "🛠", "category": "objects"},
{ "emoji": "⛏", "category": "objects"},
{ "emoji": "🔩", "category": "objects"},
{ "emoji": "⚙️", "category": "objects"},
{ "emoji": "⛓", "category": "objects"},
{ "emoji": "🔫", "category": "objects"},
{ "emoji": "💣", "category": "objects"},
{ "emoji": "🔪", "category": "objects"},
{ "emoji": "🗡", "category": "objects"},
{ "emoji": "⚔️", "category": "objects"},
{ "emoji": "🛡", "category": "objects"},
{ "emoji": "🚬", "category": "objects"},
{ "emoji": "⚰️", "category": "objects"},
{ "emoji": "⚱️", "category": "objects"},
{ "emoji": "🏺", "category": "objects"},
{ "emoji": "🔮", "category": "objects"},
{ "emoji": "📿", "category": "objects"},
{ "emoji": "💈", "category": "objects"},
{ "emoji": "⚗️", "category": "objects"},
{ "emoji": "🔭", "category": "objects"},
{ "emoji": "🔬", "category": "objects"},
{ "emoji": "🕳", "category": "objects"},
{ "emoji": "💊", "category": "objects"},
{ "emoji": "💉", "category": "objects"},
{ "emoji": "🌡", "category": "objects"},
{ "emoji": "🚽", "category": "objects"},
{ "emoji": "🚰", "category": "objects"},
{ "emoji": "🚿", "category": "objects"},
{ "emoji": "🛁", "category": "objects"},
{ "emoji": "🛀", "category": "objects"},
{ "emoji": "🛎", "category": "objects"},
{ "emoji": "🔑", "category": "objects"},
{ "emoji": "🗝", "category": "objects"},
{ "emoji": "🚪", "category": "objects"},
{ "emoji": "🛋", "category": "objects"},
{ "emoji": "🛏", "category": "objects"},
{ "emoji": "🛌", "category": "objects"},
{ "emoji": "🖼", "category": "objects"},
{ "emoji": "🛍", "category": "objects"},
{ "emoji": "🛒", "category": "objects"},
{ "emoji": "🎁", "category": "objects"},
{ "emoji": "🎈", "category": "objects"},
{ "emoji": "🎏", "category": "objects"},
{ "emoji": "🎀", "category": "objects"},
{ "emoji": "🎊", "category": "objects"},
{ "emoji": "🎉", "category": "objects"},
{ "emoji": "🎎", "category": "objects"},
{ "emoji": "🏮", "category": "objects"},
{ "emoji": "🎐", "category": "objects"},
{ "emoji": "✉️", "category": "objects"},
{ "emoji": "📩", "category": "objects"},
{ "emoji": "📨", "category": "objects"},
{ "emoji": "📧", "category": "objects"},
{ "emoji": "💌", "category": "objects"},
{ "emoji": "📥", "category": "objects"},
{ "emoji": "📤", "category": "objects"},
{ "emoji": "📦", "category": "objects"},
{ "emoji": "🏷", "category": "objects"},
{ "emoji": "📪", "category": "objects"},
{ "emoji": "📫", "category": "objects"},
{ "emoji": "📬", "category": "objects"},
{ "emoji": "📭", "category": "objects"},
{ "emoji": "📮", "category": "objects"},
{ "emoji": "📯", "category": "objects"},
{ "emoji": "📜", "category": "objects"},
{ "emoji": "📃", "category": "objects"},
{ "emoji": "📄", "category": "objects"},
{ "emoji": "📑", "category": "objects"},
{ "emoji": "📊", "category": "objects"},
{ "emoji": "📈", "category": "objects"},
{ "emoji": "📉", "category": "objects"},
{ "emoji": "🗒", "category": "objects"},
{ "emoji": "🗓", "category": "objects"},
{ "emoji": "📆", "category": "objects"},
{ "emoji": "📅", "category": "objects"},
{ "emoji": "📇", "category": "objects"},
{ "emoji": "🗃", "category": "objects"},
{ "emoji": "🗳", "category": "objects"},
{ "emoji": "🗄", "category": "objects"},
{ "emoji": "📋", "category": "objects"},
{ "emoji": "📁", "category": "objects"},
{ "emoji": "📂", "category": "objects"},
{ "emoji": "🗂", "category": "objects"},
{ "emoji": "🗞", "category": "objects"},
{ "emoji": "📰", "category": "objects"},
{ "emoji": "📓", "category": "objects"},
{ "emoji": "📔", "category": "objects"},
{ "emoji": "📒", "category": "objects"},
{ "emoji": "📕", "category": "objects"},
{ "emoji": "📗", "category": "objects"},
{ "emoji": "📘", "category": "objects"},
{ "emoji": "📙", "category": "objects"},
{ "emoji": "📚", "category": "objects"},
{ "emoji": "📖", "category": "objects"},
{ "emoji": "🔖", "category": "objects"},
{ "emoji": "🔗", "category": "objects"},
{ "emoji": "📎", "category": "objects"},
{ "emoji": "🖇", "category": "objects"},
{ "emoji": "📐", "category": "objects"},
{ "emoji": "📏", "category": "objects"},
{ "emoji": "📌", "category": "objects"},
{ "emoji": "📍", "category": "objects"},
{ "emoji": "✂️", "category": "objects"},
{ "emoji": "🖊", "category": "objects"},
{ "emoji": "🖋", "category": "objects"},
{ "emoji": "✒️", "category": "objects"},
{ "emoji": "🖌", "category": "objects"},
{ "emoji": "🖍", "category": "objects"},
{ "emoji": "📝", "category": "objects"},
{ "emoji": "✏️", "category": "objects"},
{ "emoji": "🔍", "category": "objects"},
{ "emoji": "🔎", "category": "objects"},
{ "emoji": "🔏", "category": "objects"},
{ "emoji": "🔐", "category": "objects"},
{ "emoji": "🔒", "category": "objects"},
{ "emoji": "🔓", "category": "objects"},
{ "emoji": "❤️", "category": "symbols"},
{ "emoji": "💛", "category": "symbols"},
{ "emoji": "💚", "category": "symbols"},
{ "emoji": "💙", "category": "symbols"},
{ "emoji": "💜", "category": "symbols"},
{ "emoji": "🖤", "category": "symbols"},
{ "emoji": "💔", "category": "symbols"},
{ "emoji": "❣️", "category": "symbols"},
{ "emoji": "💕", "category": "symbols"},
{ "emoji": "💞", "category": "symbols"},
{ "emoji": "💓", "category": "symbols"},
{ "emoji": "💗", "category": "symbols"},
{ "emoji": "💖", "category": "symbols"},
{ "emoji": "💘", "category": "symbols"},
{ "emoji": "💝", "category": "symbols"},
{ "emoji": "💟", "category": "symbols"},
{ "emoji": "☮️", "category": "symbols"},
{ "emoji": "✝️", "category": "symbols"},
{ "emoji": "☪️", "category": "symbols"},
{ "emoji": "🕉", "category": "symbols"},
{ "emoji": "☸️", "category": "symbols"},
{ "emoji": "✡️", "category": "symbols"},
{ "emoji": "🔯", "category": "symbols"},
{ "emoji": "🕎", "category": "symbols"},
{ "emoji": "☯️", "category": "symbols"},
{ "emoji": "☦️", "category": "symbols"},
{ "emoji": "🛐", "category": "symbols"},
{ "emoji": "⛎", "category": "symbols"},
{ "emoji": "♈️", "category": "symbols"},
{ "emoji": "♉️", "category": "symbols"},
{ "emoji": "♊️", "category": "symbols"},
{ "emoji": "♋️", "category": "symbols"},
{ "emoji": "♌️", "category": "symbols"},
{ "emoji": "♍️", "category": "symbols"},
{ "emoji": "♎️", "category": "symbols"},
{ "emoji": "♏️", "category": "symbols"},
{ "emoji": "♐️", "category": "symbols"},
{ "emoji": "♑️", "category": "symbols"},
{ "emoji": "♒️", "category": "symbols"},
{ "emoji": "♓️", "category": "symbols"},
{ "emoji": "🆔", "category": "symbols"},
{ "emoji": "⚛️", "category": "symbols"},
{ "emoji": "🉑", "category": "symbols"},
{ "emoji": "☢️", "category": "symbols"},
{ "emoji": "☣️", "category": "symbols"},
{ "emoji": "📴", "category": "symbols"},
{ "emoji": "📳", "category": "symbols"},
{ "emoji": "🈶", "category": "symbols"},
{ "emoji": "🈚️", "category": "symbols"},
{ "emoji": "🈸", "category": "symbols"},
{ "emoji": "🈺", "category": "symbols"},
{ "emoji": "🈷️", "category": "symbols"},
{ "emoji": "✴️", "category": "symbols"},
{ "emoji": "🆚", "category": "symbols"},
{ "emoji": "💮", "category": "symbols"},
{ "emoji": "🉐", "category": "symbols"},
{ "emoji": "㊙️", "category": "symbols"},
{ "emoji": "㊗️", "category": "symbols"},
{ "emoji": "🈴", "category": "symbols"},
{ "emoji": "🈵", "category": "symbols"},
{ "emoji": "🈹", "category": "symbols"},
{ "emoji": "🈲", "category": "symbols"},
{ "emoji": "🅰️", "category": "symbols"},
{ "emoji": "🅱️", "category": "symbols"},
{ "emoji": "🆎", "category": "symbols"},
{ "emoji": "🆑", "category": "symbols"},
{ "emoji": "🅾️", "category": "symbols"},
{ "emoji": "🆘", "category": "symbols"},
{ "emoji": "❌", "category": "symbols"},
{ "emoji": "⭕️", "category": "symbols"},
{ "emoji": "🛑", "category": "symbols"},
{ "emoji": "⛔️", "category": "symbols"},
{ "emoji": "📛", "category": "symbols"},
{ "emoji": "🚫", "category": "symbols"},
{ "emoji": "💯", "category": "symbols"},
{ "emoji": "💢", "category": "symbols"},
{ "emoji": "♨️", "category": "symbols"},
{ "emoji": "🚷", "category": "symbols"},
{ "emoji": "🚯", "category": "symbols"},
{ "emoji": "🚳", "category": "symbols"},
{ "emoji": "🚱", "category": "symbols"},
{ "emoji": "🔞", "category": "symbols"},
{ "emoji": "📵", "category": "symbols"},
{ "emoji": "🚭", "category": "symbols"},
{ "emoji": "❗️", "category": "symbols"},
{ "emoji": "❕", "category": "symbols"},
{ "emoji": "❓", "category": "symbols"},
{ "emoji": "❔", "category": "symbols"},
{ "emoji": "‼️", "category": "symbols"},
{ "emoji": "⁉️", "category": "symbols"},
{ "emoji": "🔅", "category": "symbols"},
{ "emoji": "🔆", "category": "symbols"},
{ "emoji": "〽️", "category": "symbols"},
{ "emoji": "⚠️", "category": "symbols"},
{ "emoji": "🚸", "category": "symbols"},
{ "emoji": "🔱", "category": "symbols"},
{ "emoji": "⚜️", "category": "symbols"},
{ "emoji": "🔰", "category": "symbols"},
{ "emoji": "♻️", "category": "symbols"},
{ "emoji": "✅", "category": "symbols"},
{ "emoji": "🈯️", "category": "symbols"},
{ "emoji": "💹", "category": "symbols"},
{ "emoji": "❇️", "category": "symbols"},
{ "emoji": "✳️", "category": "symbols"},
{ "emoji": "❎", "category": "symbols"},
{ "emoji": "🌐", "category": "symbols"},
{ "emoji": "💠", "category": "symbols"},
{ "emoji": "Ⓜ️", "category": "symbols"},
{ "emoji": "🌀", "category": "symbols"},
{ "emoji": "💤", "category": "symbols"},
{ "emoji": "🏧", "category": "symbols"},
{ "emoji": "🚾", "category": "symbols"},
{ "emoji": "♿️", "category": "symbols"},
{ "emoji": "🅿️", "category": "symbols"},
{ "emoji": "🈳", "category": "symbols"},
{ "emoji": "🈂️", "category": "symbols"},
{ "emoji": "🛂", "category": "symbols"},
{ "emoji": "🛃", "category": "symbols"},
{ "emoji": "🛄", "category": "symbols"},
{ "emoji": "🛅", "category": "symbols"},
{ "emoji": "🚹", "category": "symbols"},
{ "emoji": "🚺", "category": "symbols"},
{ "emoji": "🚼", "category": "symbols"},
{ "emoji": "🚻", "category": "symbols"},
{ "emoji": "🚮", "category": "symbols"},
{ "emoji": "🎦", "category": "symbols"},
{ "emoji": "📶", "category": "symbols"},
{ "emoji": "🈁", "category": "symbols"},
{ "emoji": "🔣", "category": "symbols"},
{ "emoji": "ℹ️", "category": "symbols"},
{ "emoji": "🔤", "category": "symbols"},
{ "emoji": "🔡", "category": "symbols"},
{ "emoji": "🔠", "category": "symbols"},
{ "emoji": "🆖", "category": "symbols"},
{ "emoji": "🆗", "category": "symbols"},
{ "emoji": "🆙", "category": "symbols"},
{ "emoji": "🆒", "category": "symbols"},
{ "emoji": "🆕", "category": "symbols"},
{ "emoji": "🆓", "category": "symbols"},
{ "emoji": "0️⃣", "category": "symbols"},
{ "emoji": "1️⃣", "category": "symbols"},
{ "emoji": "2️⃣", "category": "symbols"},
{ "emoji": "3️⃣", "category": "symbols"},
{ "emoji": "4️⃣", "category": "symbols"},
{ "emoji": "5️⃣", "category": "symbols"},
{ "emoji": "6️⃣", "category": "symbols"},
{ "emoji": "7️⃣", "category": "symbols"},
{ "emoji": "8️⃣", "category": "symbols"},
{ "emoji": "9️⃣", "category": "symbols"},
{ "emoji": "🔟", "category": "symbols"},
{ "emoji": "🔢", "category": "symbols"},
{ "emoji": "#️⃣", "category": "symbols"},
{ "emoji": "*️⃣", "category": "symbols"},
{ "emoji": "▶️", "category": "symbols"},
{ "emoji": "⏸", "category": "symbols"},
{ "emoji": "⏯", "category": "symbols"},
{ "emoji": "⏹", "category": "symbols"},
{ "emoji": "⏺", "category": "symbols"},
{ "emoji": "⏭", "category": "symbols"},
{ "emoji": "⏮", "category": "symbols"},
{ "emoji": "⏩", "category": "symbols"},
{ "emoji": "⏪", "category": "symbols"},
{ "emoji": "⏫", "category": "symbols"},
{ "emoji": "⏬", "category": "symbols"},
{ "emoji": "◀️", "category": "symbols"},
{ "emoji": "🔼", "category": "symbols"},
{ "emoji": "🔽", "category": "symbols"},
{ "emoji": "➡️", "category": "symbols"},
{ "emoji": "⬅️", "category": "symbols"},
{ "emoji": "⬆️", "category": "symbols"},
{ "emoji": "⬇️", "category": "symbols"},
{ "emoji": "↗️", "category": "symbols"},
{ "emoji": "↘️", "category": "symbols"},
{ "emoji": "↙️", "category": "symbols"},
{ "emoji": "↖️", "category": "symbols"},
{ "emoji": "↕️", "category": "symbols"},
{ "emoji": "↔️", "category": "symbols"},
{ "emoji": "↪️", "category": "symbols"},
{ "emoji": "↩️", "category": "symbols"},
{ "emoji": "⤴️", "category": "symbols"},
{ "emoji": "⤵️", "category": "symbols"},
{ "emoji": "🔀", "category": "symbols"},
{ "emoji": "🔁", "category": "symbols"},
{ "emoji": "🔂", "category": "symbols"},
{ "emoji": "🔄", "category": "symbols"},
{ "emoji": "🔃", "category": "symbols"},
{ "emoji": "🎵", "category": "symbols"},
{ "emoji": "🎶", "category": "symbols"},
{ "emoji": "➕", "category": "symbols"},
{ "emoji": "➖", "category": "symbols"},
{ "emoji": "➗", "category": "symbols"},
{ "emoji": "✖️", "category": "symbols"},
{ "emoji": "💲", "category": "symbols"},
{ "emoji": "💱", "category": "symbols"},
{ "emoji": "™️", "category": "symbols"},
{ "emoji": "©️", "category": "symbols"},
{ "emoji": "®️", "category": "symbols"},
{ "emoji": "〰️", "category": "symbols"},
{ "emoji": "➰", "category": "symbols"},
{ "emoji": "➿", "category": "symbols"},
{ "emoji": "🔚", "category": "symbols"},
{ "emoji": "🔙", "category": "symbols"},
{ "emoji": "🔛", "category": "symbols"},
{ "emoji": "🔝", "category": "symbols"},
{ "emoji": "🔜", "category": "symbols"},
{ "emoji": "✔️", "category": "symbols"},
{ "emoji": "☑️", "category": "symbols"},
{ "emoji": "🔘", "category": "symbols"},
{ "emoji": "⚪️", "category": "symbols"},
{ "emoji": "⚫️", "category": "symbols"},
{ "emoji": "🔴", "category": "symbols"},
{ "emoji": "🔵", "category": "symbols"},
{ "emoji": "🔺", "category": "symbols"},
{ "emoji": "🔻", "category": "symbols"},
{ "emoji": "🔸", "category": "symbols"},
{ "emoji": "🔹", "category": "symbols"},
{ "emoji": "🔶", "category": "symbols"},
{ "emoji": "🔷", "category": "symbols"},
{ "emoji": "🔳", "category": "symbols"},
{ "emoji": "🔲", "category": "symbols"},
{ "emoji": "▪️", "category": "symbols"},
{ "emoji": "▫️", "category": "symbols"},
{ "emoji": "◾️", "category": "symbols"},
{ "emoji": "◽️", "category": "symbols"},
{ "emoji": "◼️", "category": "symbols"},
{ "emoji": "◻️", "category": "symbols"},
{ "emoji": "⬛️", "category": "symbols"},
{ "emoji": "⬜️", "category": "symbols"},
{ "emoji": "🔈", "category": "symbols"},
{ "emoji": "🔇", "category": "symbols"},
{ "emoji": "🔉", "category": "symbols"},
{ "emoji": "🔊", "category": "symbols"},
{ "emoji": "🔔", "category": "symbols"},
{ "emoji": "🔕", "category": "symbols"},
{ "emoji": "📣", "category": "symbols"},
{ "emoji": "📢", "category": "symbols"},
{ "emoji": "👁‍🗨", "category": "symbols"},
{ "emoji": "💬", "category": "symbols"},
{ "emoji": "💭", "category": "symbols"},
{ "emoji": "🗯", "category": "symbols"},
{ "emoji": "♠️", "category": "symbols"},
{ "emoji": "♣️", "category": "symbols"},
{ "emoji": "♥️", "category": "symbols"},
{ "emoji": "♦️", "category": "symbols"},
{ "emoji": "🃏", "category": "symbols"},
{ "emoji": "🎴", "category": "symbols"},
{ "emoji": "🀄️", "category": "symbols"},
{ "emoji": "🕐", "category": "symbols"},
{ "emoji": "🕑", "category": "symbols"},
{ "emoji": "🕒", "category": "symbols"},
{ "emoji": "🕓", "category": "symbols"},
{ "emoji": "🕔", "category": "symbols"},
{ "emoji": "🕕", "category": "symbols"},
{ "emoji": "🕖", "category": "symbols"},
{ "emoji": "🕗", "category": "symbols"},
{ "emoji": "🕘", "category": "symbols"},
{ "emoji": "🕙", "category": "symbols"},
{ "emoji": "🕚", "category": "symbols"},
{ "emoji": "🕛", "category": "symbols"},
{ "emoji": "🕜", "category": "symbols"},
{ "emoji": "🕝", "category": "symbols"},
{ "emoji": "🕞", "category": "symbols"},
{ "emoji": "🕟", "category": "symbols"},
{ "emoji": "🕠", "category": "symbols"},
{ "emoji": "🕡", "category": "symbols"},
{ "emoji": "🕢", "category": "symbols"},
{ "emoji": "🕣", "category": "symbols"},
{ "emoji": "🕤", "category": "symbols"},
{ "emoji": "🕥", "category": "symbols"},
{ "emoji": "🕦", "category": "symbols"},
{ "emoji": "🕧", "category": "symbols"},
{ "emoji": "🏳️", "category": "flags"},
{ "emoji": "🏴", "category": "flags"},
{ "emoji": "🏁", "category": "flags"},
{ "emoji": "🚩", "category": "flags"},
{ "emoji": "🏳️‍🌈", "category": "flags"},
{ "emoji": "🇦🇫", "category": "flags"},
{ "emoji": "🇦🇽", "category": "flags"},
{ "emoji": "🇦🇱", "category": "flags"},
{ "emoji": "🇩🇿", "category": "flags"},
{ "emoji": "🇦🇸", "category": "flags"},
{ "emoji": "🇦🇩", "category": "flags"},
{ "emoji": "🇦🇴", "category": "flags"},
{ "emoji": "🇦🇮", "category": "flags"},
{ "emoji": "🇦🇶", "category": "flags"},
{ "emoji": "🇦🇬", "category": "flags"},
{ "emoji": "🇦🇷", "category": "flags"},
{ "emoji": "🇦🇲", "category": "flags"},
{ "emoji": "🇦🇼", "category": "flags"},
{ "emoji": "🇦🇺", "category": "flags"},
{ "emoji": "🇦🇹", "category": "flags"},
{ "emoji": "🇦🇿", "category": "flags"},
{ "emoji": "🇧🇸", "category": "flags"},
{ "emoji": "🇧🇭", "category": "flags"},
{ "emoji": "🇧🇩", "category": "flags"},
{ "emoji": "🇧🇧", "category": "flags"},
{ "emoji": "🇧🇾", "category": "flags"},
{ "emoji": "🇧🇪", "category": "flags"},
{ "emoji": "🇧🇿", "category": "flags"},
{ "emoji": "🇧🇯", "category": "flags"},
{ "emoji": "🇧🇲", "category": "flags"},
{ "emoji": "🇧🇹", "category": "flags"},
{ "emoji": "🇧🇴", "category": "flags"},
{ "emoji": "🇧🇶", "category": "flags"},
{ "emoji": "🇧🇦", "category": "flags"},
{ "emoji": "🇧🇼", "category": "flags"},
{ "emoji": "🇧🇷", "category": "flags"},
{ "emoji": "🇮🇴", "category": "flags"},
{ "emoji": "🇻🇬", "category": "flags"},
{ "emoji": "🇧🇳", "category": "flags"},
{ "emoji": "🇧🇬", "category": "flags"},
{ "emoji": "🇧🇫", "category": "flags"},
{ "emoji": "🇧🇮", "category": "flags"},
{ "emoji": "🇨🇻", "category": "flags"},
{ "emoji": "🇰🇭", "category": "flags"},
{ "emoji": "🇨🇲", "category": "flags"},
{ "emoji": "🇨🇦", "category": "flags"},
{ "emoji": "🇮🇨", "category": "flags"},
{ "emoji": "🇰🇾", "category": "flags"},
{ "emoji": "🇨🇫", "category": "flags"},
{ "emoji": "🇹🇩", "category": "flags"},
{ "emoji": "🇨🇱", "category": "flags"},
{ "emoji": "🇨🇳", "category": "flags"},
{ "emoji": "🇨🇽", "category": "flags"},
{ "emoji": "🇨🇨", "category": "flags"},
{ "emoji": "🇨🇴", "category": "flags"},
{ "emoji": "🇰🇲", "category": "flags"},
{ "emoji": "🇨🇬", "category": "flags"},
{ "emoji": "🇨🇩", "category": "flags"},
{ "emoji": "🇨🇰", "category": "flags"},
{ "emoji": "🇨🇷", "category": "flags"},
{ "emoji": "🇨🇮", "category": "flags"},
{ "emoji": "🇭🇷", "category": "flags"},
{ "emoji": "🇨🇺", "category": "flags"},
{ "emoji": "🇨🇼", "category": "flags"},
{ "emoji": "🇨🇾", "category": "flags"},
{ "emoji": "🇨🇿", "category": "flags"},
{ "emoji": "🇩🇰", "category": "flags"},
{ "emoji": "🇩🇯", "category": "flags"},
{ "emoji": "🇩🇲", "category": "flags"},
{ "emoji": "🇩🇴", "category": "flags"},
{ "emoji": "🇪🇨", "category": "flags"},
{ "emoji": "🇪🇬", "category": "flags"},
{ "emoji": "🇸🇻", "category": "flags"},
{ "emoji": "🇬🇶", "category": "flags"},
{ "emoji": "🇪🇷", "category": "flags"},
{ "emoji": "🇪🇪", "category": "flags"},
{ "emoji": "🇪🇹", "category": "flags"},
{ "emoji": "🇪🇺", "category": "flags"},
{ "emoji": "🇫🇰", "category": "flags"},
{ "emoji": "🇫🇴", "category": "flags"},
{ "emoji": "🇫🇯", "category": "flags"},
{ "emoji": "🇫🇮", "category": "flags"},
{ "emoji": "🇫🇷", "category": "flags"},
{ "emoji": "🇬🇫", "category": "flags"},
{ "emoji": "🇵🇫", "category": "flags"},
{ "emoji": "🇹🇫", "category": "flags"},
{ "emoji": "🇬🇦", "category": "flags"},
{ "emoji": "🇬🇲", "category": "flags"},
{ "emoji": "🇬🇪", "category": "flags"},
{ "emoji": "🇩🇪", "category": "flags"},
{ "emoji": "🇬🇭", "category": "flags"},
{ "emoji": "🇬🇮", "category": "flags"},
{ "emoji": "🇬🇷", "category": "flags"},
{ "emoji": "🇬🇱", "category": "flags"},
{ "emoji": "🇬🇩", "category": "flags"},
{ "emoji": "🇬🇵", "category": "flags"},
{ "emoji": "🇬🇺", "category": "flags"},
{ "emoji": "🇬🇹", "category": "flags"},
{ "emoji": "🇬🇬", "category": "flags"},
{ "emoji": "🇬🇳", "category": "flags"},
{ "emoji": "🇬🇼", "category": "flags"},
{ "emoji": "🇬🇾", "category": "flags"},
{ "emoji": "🇭🇹", "category": "flags"},
{ "emoji": "🇭🇳", "category": "flags"},
{ "emoji": "🇭🇰", "category": "flags"},
{ "emoji": "🇭🇺", "category": "flags"},
{ "emoji": "🇮🇸", "category": "flags"},
{ "emoji": "🇮🇳", "category": "flags"},
{ "emoji": "🇮🇩", "category": "flags"},
{ "emoji": "🇮🇷", "category": "flags"},
{ "emoji": "🇮🇶", "category": "flags"},
{ "emoji": "🇮🇪", "category": "flags"},
{ "emoji": "🇮🇲", "category": "flags"},
{ "emoji": "🇮🇱", "category": "flags"},
{ "emoji": "🇮🇹", "category": "flags"},
{ "emoji": "🇯🇲", "category": "flags"},
{ "emoji": "🇯🇵", "category": "flags"},
{ "emoji": "🎌", "category": "flags"},
{ "emoji": "🇯🇪", "category": "flags"},
{ "emoji": "🇯🇴", "category": "flags"},
{ "emoji": "🇰🇿", "category": "flags"},
{ "emoji": "🇰🇪", "category": "flags"},
{ "emoji": "🇰🇮", "category": "flags"},
{ "emoji": "🇽🇰", "category": "flags"},
{ "emoji": "🇰🇼", "category": "flags"},
{ "emoji": "🇰🇬", "category": "flags"},
{ "emoji": "🇱🇦", "category": "flags"},
{ "emoji": "🇱🇻", "category": "flags"},
{ "emoji": "🇱🇧", "category": "flags"},
{ "emoji": "🇱🇸", "category": "flags"},
{ "emoji": "🇱🇷", "category": "flags"},
{ "emoji": "🇱🇾", "category": "flags"},
{ "emoji": "🇱🇮", "category": "flags"},
{ "emoji": "🇱🇹", "category": "flags"},
{ "emoji": "🇱🇺", "category": "flags"},
{ "emoji": "🇲🇴", "category": "flags"},
{ "emoji": "🇲🇰", "category": "flags"},
{ "emoji": "🇲🇬", "category": "flags"},
{ "emoji": "🇲🇼", "category": "flags"},
{ "emoji": "🇲🇾", "category": "flags"},
{ "emoji": "🇲🇻", "category": "flags"},
{ "emoji": "🇲🇱", "category": "flags"},
{ "emoji": "🇲🇹", "category": "flags"},
{ "emoji": "🇲🇭", "category": "flags"},
{ "emoji": "🇲🇶", "category": "flags"},
{ "emoji": "🇲🇷", "category": "flags"},
{ "emoji": "🇲🇺", "category": "flags"},
{ "emoji": "🇾🇹", "category": "flags"},
{ "emoji": "🇲🇽", "category": "flags"},
{ "emoji": "🇫🇲", "category": "flags"},
{ "emoji": "🇲🇩", "category": "flags"},
{ "emoji": "🇲🇨", "category": "flags"},
{ "emoji": "🇲🇳", "category": "flags"},
{ "emoji": "🇲🇪", "category": "flags"},
{ "emoji": "🇲🇸", "category": "flags"},
{ "emoji": "🇲🇦", "category": "flags"},
{ "emoji": "🇲🇿", "category": "flags"},
{ "emoji": "🇲🇲", "category": "flags"},
{ "emoji": "🇳🇦", "category": "flags"},
{ "emoji": "🇳🇷", "category": "flags"},
{ "emoji": "🇳🇵", "category": "flags"},
{ "emoji": "🇳🇱", "category": "flags"},
{ "emoji": "🇳🇨", "category": "flags"},
{ "emoji": "🇳🇿", "category": "flags"},
{ "emoji": "🇳🇮", "category": "flags"},
{ "emoji": "🇳🇪", "category": "flags"},
{ "emoji": "🇳🇬", "category": "flags"},
{ "emoji": "🇳🇺", "category": "flags"},
{ "emoji": "🇳🇫", "category": "flags"},
{ "emoji": "🇲🇵", "category": "flags"},
{ "emoji": "🇰🇵", "category": "flags"},
{ "emoji": "🇳🇴", "category": "flags"},
{ "emoji": "🇴🇲", "category": "flags"},
{ "emoji": "🇵🇰", "category": "flags"},
{ "emoji": "🇵🇼", "category": "flags"},
{ "emoji": "🇵🇸", "category": "flags"},
{ "emoji": "🇵🇦", "category": "flags"},
{ "emoji": "🇵🇬", "category": "flags"},
{ "emoji": "🇵🇾", "category": "flags"},
{ "emoji": "🇵🇪", "category": "flags"},
{ "emoji": "🇵🇭", "category": "flags"},
{ "emoji": "🇵🇳", "category": "flags"},
{ "emoji": "🇵🇱", "category": "flags"},
{ "emoji": "🇵🇹", "category": "flags"},
{ "emoji": "🇵🇷", "category": "flags"},
{ "emoji": "🇶🇦", "category": "flags"},
{ "emoji": "🇷🇪", "category": "flags"},
{ "emoji": "🇷🇴", "category": "flags"},
{ "emoji": "🇷🇺", "category": "flags"},
{ "emoji": "🇷🇼", "category": "flags"},
{ "emoji": "🇧🇱", "category": "flags"},
{ "emoji": "🇸🇭", "category": "flags"},
{ "emoji": "🇰🇳", "category": "flags"},
{ "emoji": "🇱🇨", "category": "flags"},
{ "emoji": "🇵🇲", "category": "flags"},
{ "emoji": "🇻🇨", "category": "flags"},
{ "emoji": "🇼🇸", "category": "flags"},
{ "emoji": "🇸🇲", "category": "flags"},
{ "emoji": "🇸🇹", "category": "flags"},
{ "emoji": "🇸🇦", "category": "flags"},
{ "emoji": "🇸🇳", "category": "flags"},
{ "emoji": "🇷🇸", "category": "flags"},
{ "emoji": "🇸🇨", "category": "flags"},
{ "emoji": "🇸🇱", "category": "flags"},
{ "emoji": "🇸🇬", "category": "flags"},
{ "emoji": "🇸🇽", "category": "flags"},
{ "emoji": "🇸🇰", "category": "flags"},
{ "emoji": "🇸🇮", "category": "flags"},
{ "emoji": "🇸🇧", "category": "flags"},
{ "emoji": "🇸🇴", "category": "flags"},
{ "emoji": "🇿🇦", "category": "flags"},
{ "emoji": "🇬🇸", "category": "flags"},
{ "emoji": "🇰🇷", "category": "flags"},
{ "emoji": "🇸🇸", "category": "flags"},
{ "emoji": "🇪🇸", "category": "flags"},
{ "emoji": "🇱🇰", "category": "flags"},
{ "emoji": "🇸🇩", "category": "flags"},
{ "emoji": "🇸🇷", "category": "flags"},
{ "emoji": "🇸🇿", "category": "flags"},
{ "emoji": "🇸🇪", "category": "flags"},
{ "emoji": "🇨🇭", "category": "flags"},
{ "emoji": "🇸🇾", "category": "flags"},
{ "emoji": "🇹🇼", "category": "flags"},
{ "emoji": "🇹🇯", "category": "flags"},
{ "emoji": "🇹🇿", "category": "flags"},
{ "emoji": "🇹🇭", "category": "flags"},
{ "emoji": "🇹🇱", "category": "flags"},
{ "emoji": "🇹🇬", "category": "flags"},
{ "emoji": "🇹🇰", "category": "flags"},
{ "emoji": "🇹🇴", "category": "flags"},
{ "emoji": "🇹🇹", "category": "flags"},
{ "emoji": "🇹🇳", "category": "flags"},
{ "emoji": "🇹🇷", "category": "flags"},
{ "emoji": "🇹🇲", "category": "flags"},
{ "emoji": "🇹🇨", "category": "flags"},
{ "emoji": "🇹🇻", "category": "flags"},
{ "emoji": "🇺🇬", "category": "flags"},
{ "emoji": "🇺🇦", "category": "flags"},
{ "emoji": "🇦🇪", "category": "flags"},
{ "emoji": "🇬🇧", "category": "flags"},
{ "emoji": "🇺🇸", "category": "flags"},
{ "emoji": "🇻🇮", "category": "flags"},
{ "emoji": "🇺🇾", "category": "flags"},
{ "emoji": "🇺🇿", "category": "flags"},
{ "emoji": "🇻🇺", "category": "flags"},
{ "emoji": "🇻🇦", "category": "flags"},
{ "emoji": "🇻🇪", "category": "flags"},
{ "emoji": "🇻🇳", "category": "flags"},
{ "emoji": "🇼🇫", "category": "flags"},
{ "emoji": "🇪🇭", "category": "flags"},
{ "emoji": "🇾🇪", "category": "flags"},
{ "emoji": "🇿🇲", "category": "flags"},
{ "emoji": "🇿🇼", "category": "flags"}
];